import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Share } from 'lucide-react';

function ArticleDetail({ article }) {
  return (
    <div className="bg-black min-h-screen">
      {/* Hero Image */}
      <div className="relative h-[500px]">
        <img
          src={article.heroImage}
          alt={article.title}
          className="w-full h-full object-cover"
          onError={(e) => {
            // Fallback if image fails to load
            e.currentTarget.src = '/article-placeholder.jpg';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />
      </div>

      {/* Article Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 -mt-32 relative z-10">
        <div className="bg-gray-900 rounded-lg p-8 mb-12">
          <div className="flex items-center gap-4 text-gray-400 text-sm mb-6">
            <div className="flex items-center">
              <Calendar className="h-4 w-4 mr-2" />
              {article.date}
            </div>
            <div>By {article.author}</div>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-8">{article.title}</h1>
          <div className="prose prose-invert max-w-none">
            <div dangerouslySetInnerHTML={{ __html: article.content }} />
          </div>
          <div className="flex justify-end mt-8">
            <button className="flex items-center text-yellow-400 hover:text-yellow-300">
              <Share className="h-5 w-5 mr-2" />
              Share Article
            </button>
          </div>
        </div>

        {/* Related Articles */}
        {article.relatedArticles && article.relatedArticles.length > 0 && (
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-6">Related News</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {article.relatedArticles.map((related) => (
                <Link
                  key={related._id}
                  to={`/news/${related.slug.current}`}
                  className="block bg-gray-900 rounded-lg overflow-hidden border border-gray-800 hover:border-yellow-700 transition-all"
                >
                  <div className="aspect-video">
                    <img
                      src={related.image}
                      alt={related.title}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.currentTarget.src = '/article-placeholder.jpg';
                      }}
                    />
                  </div>
                  <div className="p-4">
                    <div className="text-yellow-500 text-sm mb-2">{related.date}</div>
                    <h3 className="text-white font-medium hover:text-yellow-400">
                      {related.title}
                    </h3>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ArticleDetail;
